import React, { Component } from 'react';
import AdminColorsTable from './AdminColorsTable';

export class AdminColorsContent extends Component {
  render() {

    return (
      <AdminColorsTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminColorsContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminColor/AdminColorsContent.js